import { Link, Navigate } from 'react-router'
import { useAuth } from '../auth'
import { Button } from '../components/ui'

const LAST_BUSINESS = 'tabula:last-business'

export function rememberBusiness(id: string) {
  try {
    localStorage.setItem(LAST_BUSINESS, id)
  } catch {
    /* private mode */
  }
}

/** Sends the person to their restaurant; with several, the one they used last, else a picker. */
export function HomePage() {
  const { me, signOut } = useAuth()
  if (!me) return null
  const memberships = me.memberships
  if (memberships.length === 0) return <Navigate to={me.user.isPlatformAdmin ? '/platform' : '/onboarding'} replace />
  if (memberships.length === 1) return <Navigate to={`/b/${memberships[0]!.businessId}/today`} replace />
  let last: string | null = null
  try {
    last = localStorage.getItem(LAST_BUSINESS)
  } catch {
    /* ignore */
  }
  if (last && memberships.some((m) => m.businessId === last)) return <Navigate to={`/b/${last}/today`} replace />
  return (
    <div className="auth-page">
      <div className="auth-card stack">
        <span className="brand">
          <span className="brand-mark" /> Tabula
        </span>
        <h1>Choose a restaurant</h1>
        <ul className="list-plain">
          {memberships.map((m) => (
            <li key={m.businessId}>
              <Link to={`/b/${m.businessId}/today`} onClick={() => rememberBusiness(m.businessId)}>
                {m.name}
              </Link>
              <span className="muted small">{m.role}</span>
            </li>
          ))}
        </ul>
        <div className="row-flex">
          <Link to="/onboarding" className="btn btn-secondary btn-md">
            Add a restaurant
          </Link>
          {me.user.isPlatformAdmin ? (
            <Link to="/platform" className="btn btn-secondary btn-md">
              Platform
            </Link>
          ) : null}
          <Button variant="ghost" onClick={() => void signOut()}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  )
}
